import {
  ApplicationConfig,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { loaderInterceptor } from '@core/components/loader/loader.interceptor';
import { blobInterceptor } from '@shared/services/blob.interceptor';
import { jwtInterceptor } from '@core/interceptors/jwt.interceptor';
import { showErrorInterceptor } from '@core/interceptors/catch-errors.interceptor';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        jwtInterceptor,
        loaderInterceptor,
        showErrorInterceptor,
        blobInterceptor,
      ]),
    ),
    MessageService,
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: 'none',
          cssLayer: {
            name: 'primeng',
            order: 'customPrimeflex, primeng, customPrimeng',
          },
        },
      },
    }),
  ],
};
